import { render, staticRenderFns } from "./GlobalsForm.vue?vue&type=template&id=d30f785c&scoped=true&"
import script from "./GlobalsForm.vue?vue&type=script&lang=js&"
export * from "./GlobalsForm.vue?vue&type=script&lang=js&"
import style0 from "./GlobalsForm.vue?vue&type=style&index=0&id=d30f785c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30f785c",
  null
  
)

export default component.exports